<template>
    <div class="customization " >
                <div class="notaryServices_content_title">定制化公证咨询服务</div>
                  <div class="notaryServices_gzzx">
                    <div class="notaryServices_gzzximg">
                         <div class="notaryServices_background">
                             <div class="notaryServices_background_text">欢迎</div>
                             <div class="notaryServices_background_text1">进行公证咨询</div>
                         </div>
                    </div>
                     <div class="notaryServices_gzzxtext">
                           <el-form
                            ref="ruleFormRef"
                            :model="ruleForm"
                            :rules="rules"
                            label-width="120px"
                            class="demo-ruleForm"
                            :size="formSize"
                            status-icon
                        >
                        <el-row :gutter="24">
                        <el-col :span="12" :class="['wui-input-error-color-' + themeColor]">     
                             <el-form-item label="咨询地区：" prop="dqdm">
                            <!-- <el-input v-model="ruleForm.name"  placeholder="请选择咨询地区" style="height: 40px;" /> -->
                                <el-cascader
                                 :teleported="false"
                                class="h40"
                                placeholder="请选择咨询地区"
                                ref="cascaderZxdq"
                                filterable
                                  style="height: 40px;width: 100%;"
                                  v-model="ruleForm.dqdm"
                                  :options="areaData"
                                  :props="{'value':'code','label':'name'}"
                                  @change="handlezxdq"
                                />
                            </el-form-item>
                        </el-col>
                         <el-col :span="12" :class="['wui-input-error-color-' + themeColor]">     
                             <el-form-item label="咨询业务：" prop="zxyw">
                               <el-cascader
                                :teleported="false"
                                class="h40"
                               placeholder="请选择咨询业务"
                                ref="cascaderYwzx"
                                filterable
                                  style="height: 40px;width: 100%;"
                                   v-model="ruleForm.zxyw"
                                  :options="ywzx"
                                  :props="{
                                      value: 'name',
                                    label: 'name',
                                    children: 'children'
                                  }"
                                  @change="handleywzx"
                                />
                          
                            </el-form-item>
                        </el-col>
                         <el-col :span="12" :class="['wui-input-error-color-' + themeColor]">     
                             <el-form-item label="公司名称：" prop="gsmc">
                            <el-input v-model="ruleForm.gsmc"  placeholder="请输入公司名称" style="height: 40px;" />
                            </el-form-item>
                        </el-col>
                         <el-col :span="12" :class="['wui-input-error-color-' + themeColor]">     
                             <el-form-item label="公司职务：" prop="gszw">
                            <el-input v-model="ruleForm.gszw "  placeholder="请输入公司职务" style="height: 40px;" />
                            </el-form-item>
                        </el-col>
                         <el-col :span="12" :class="['wui-input-error-color-' + themeColor]">     
                              <!-- eslint-disable-next-line no-irregular-whitespace -->
                             <el-form-item :label="'姓' + '　'.repeat(2) + '名：'" prop="xm">
                            <el-input v-model="ruleForm.xm"  placeholder="请输入姓名" style="height: 40px;" />
                            </el-form-item>
                        </el-col>
                         <el-col :span="12" :class="['wui-input-error-color-' + themeColor]">     
                             <el-form-item label="手机号码：" prop="lxsjh">
                            <el-input v-model="ruleForm.lxsjh"  placeholder="请选择手机号码" style="height: 40px;" />
                            </el-form-item>
                        </el-col> 
                          <el-col :span="24" :class="['wui-input-error-color-' + themeColor]">     
                             <el-form-item label="咨询内容：" prop="zxnr">
                             <el-input
                                v-model="ruleForm.zxnr"
                                :autosize="{ minRows: 7, maxRows: 7 }"
                                type="textarea"
                                placeholder="请输入想要咨询公证的业务诉求"
                            />
                            </el-form-item>
                        </el-col>
                        </el-row>
                            <el-form-item>
                            <!-- <el-button type="primary" @click="submitForm(ruleFormRef)">
                                立即提交咨询
                            </el-button> -->
                              <div :class="['wui-background-color-' + themeColor]"   class="btn" @click="submitForm(ruleFormRef)">
                                立即提交咨询
                              </div>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
          
    </div>
</template>
 
<script>
import { getCurrentInstance,ref,watch,computed,onMounted,nextTick} from "vue";
import { useRoute, useRouter } from "vue-router";
export default {
  name: "secondPage",
   
  props:{
    themeColor: {
        type: String,
        default: 'blue'
    },
  },
  setup() {
    const { proxy } = getCurrentInstance();
    const router = useRouter();
    const route = useRoute();
    let articleData = ref({});
    const ruleFormRef=ref(null)
    
    
    const ruleForm= ref({})
    let articleId=ref(route.query.articleId);
    const ywzx =ref([
       {
         name:"公证事项",
      id:"1",
      children:[
        {
          name:"合同公证",
          id:"1"
        },
        {
          name:"继承公证",
          id:"2"
        },
        {
          name:"意定公证",
          id:"3"
        },
        {
          name:"财产公证",
          id:"4"
        },
        {
          name:"商事公证",
          id:"5"
        },
        {
          name:"亲属公证",
          id:"6"
        },
        {
          name:"身份公证",
          id:"6"
        },
        {
          name:"章程公证",
          id:"6"
        },
        {
          name:"证据公证",
          id:"6"
        },
        {
          name:"文证公证",
          id:"6"
        }
      
      ]
       },
         {
         name:"公证事务",
        id:"1",
      children:[
        {
          name:"法定登记",
          id:"1"
        },
        {
          name:"提存事务",
          id:"2"
        },
        {
          name:"保管事务",
          id:"3"
        },
        {
          name:"文书代拟",
          id:"4"
        },
        {
          name:"公证法律",
          id:"5"
        }
      
      ]
       }

    ])
    const rules = ref({
      xm: [
        { required: true, message: "请输入姓名", trigger: "blur" },
      
      ],   
      lxsjh: [
        { required: true, message: "请输入联系手机号", trigger: "blur" },
      
      ],
      dqdm: [
        { required: true, message: "请选择咨询地区", trigger: "change" }
      ],
      zxyw: [
        {  required: true, message: "请选择咨询业务", trigger: "change" }
      ],
      zxnr: [
        { required: true, message: "请输入咨询内容", trigger: "blur" },
      
      ],
  })
  // const [areaProvName, areaCityName, areaCouName] = myCascader.value.getCheckedNodes()[0].pathLabels||[] //名称
  //       const  [areaProv, areaCity, areaCou] = val || [] //code
  // handlezxdq
  const cascaderZxdq =ref(null)
  const cascaderYwzx =ref(null)
    const handlezxdq =(e) => {
     let valName= cascaderZxdq.value.getCheckedNodes()[0].pathLabels||[] //名称
        ruleForm.value.zxdq=valName[valName.length-1]
}
    const handleywzx =(e) => {
       cascaderYwzx.value.getCheckedNodes()[0].pathLabels||[] //名称
    }
  const submitForm = async (formEl) => {
  if (!formEl) return
  await formEl.validate((valid, fields) => {
    if (valid) {
     getDetails()
    console.log(ruleForm.value,'2222')
    } else {
      console.log('error submit!', fields)
    }
  })
}
    const getDetails=()=>{
       ruleForm.value.dqdm=ruleForm.value.dqdm[ruleForm.value.dqdm.length-1]
        ruleForm.value.zxyw=ruleForm.value.zxyw.join('-')
      proxy.$request({
        url: "FLZX_GZZXADD",
        method: "post",
        data:ruleForm.value
      }).then((res) => {
        if (res.data.code == "000") {
           proxy.$message({
            type: "success",
            message: "提交成功"
          });
          ruleForm.value={}
          ruleFormRef.value.resetFields();
        }
      }).catch((err) => {
        console.log(err);
      });
		}
    const areaData = ref([]);
    
 const filterLevel = (list, level = 1) => list.map(v => ({...v, children: level == 2 ? [] : filterLevel(v.children, level+1)}))
const findAreaTreeFn = () => { // 查询地址
    proxy
        .$request({
            url: "B2B_W_AREA_FINDAREATREE",
            data: {},
        })
        .then((res) => {
            areaData.value =filterLevel(res.data.result[0].children) 
        })
        .catch((err) => {
            console.log(err);
        });
}
        const notaryServicesref = ref(null);
        const footerHeight = ref(0);
        onMounted(async () => {
        await nextTick();
        if(notaryServicesref.value){
            footerHeight.value = notaryServicesref.value.offsetHeight
        }
        
            window.addEventListener('resize', ()=>{
            if(notaryServicesref.value){
                footerHeight.value = notaryServicesref.value.offsetHeight
            }
            });
        });
        findAreaTreeFn()
    return {
      articleData,
      notaryServicesref,
      ruleForm,
      ruleFormRef,
      ywzx,
      areaData,
      rules,
      submitForm,
      cascaderYwzx,
      cascaderZxdq,
      handlezxdq,
      handleywzx
    };
  },
};
</script>

 
<style lang="less" scoped>
.customization {
    width: 100%;
    height: 100%;
    background: #FFFFFF;
    box-sizing: border-box;
    padding-bottom: 50px;
            .notaryServices_content_title {
             box-sizing: border-box;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 50px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 30px;
            color: #313A4B;
            line-height: 42px;
        }
       .notaryServices_gzzx {
             box-sizing: border-box;
            display: flex;
            margin-top: 30px;
            .notaryServices_gzzximg {
                 box-sizing: border-box;
                width: 386px;
                height: 444px;
               .notaryServices_background {
                border-top-left-radius:20px;
                border-bottom-left-radius:20px;
                     box-sizing: border-box;
                    width: 100%;
                    height: 100%;
                    background: url(../../../assets/images/notaryServicers/gzzx.png) no-repeat;
                    background-size: 100% 100%;
                    // font-weight: 600;
                     font-size: 34px;
                    color: #FFFFFF;
                    padding-left: 46px;
                    padding-top: 235px;
                    .notaryServices_background_text {
                        
                       
                        // line-height: 48px;
                    }
                    .notaryServices_background_text1 {
                          margin-top: 9px;
                         font-weight: 600;
                 
                      
                        // line-height: 48px;
                    }
                }
            }
            .notaryServices_gzzxtext {
                box-sizing: border-box;
                flex: 1;
                background: #F9FAFC;
                padding: 28px 30px 0 30px;
                
       

            }
   
        }
}


   .btn {
        width: 134px;
        height: 40px;
        background: #0754BD;
        font-size: 14px;
        color: #FFFFFF;
        line-height: 40px;
        text-align: center;
        cursor:pointer;
        border-radius: 20px;
    }
    :deep(.h40){
        .el-input__inner{
              height: 40px;
            }
    }
    // .el-cascader 
</style>